import React, { useRef, useEffect } from "react";
import classnames from "classnames";
import DeleteIcon from "@mui/icons-material/Delete";
import StarIcon from '@mui/icons-material/Star';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import Tooltip from "@mui/material/Tooltip";

import { toast } from 'react-toastify'
import Radio from "@mui/material/Radio";
import {buildLocationString} from "../utils/utils";

export const LocationItem = ( {
                                  location,
                                  deleteLocation,
                                  isSelected,
                                  setSelectedLocation,
                                  isInitialLocation,
                                  updateLocation
}) => {
    const elementRef = useRef(null);
    const isDefaultLocation = location.is_default_location

    const updatePinnedLocation = (isPinned) => {
        const data = { is_pinned: isPinned }
        return updateLocation(location.id, data).then(() => {
            const addedOrRemoved = isPinned ? 'added' : 'removed'
            toast.success(`Successfully ${addedOrRemoved} pinned location.`)
        })
    }

    const scrollToElement = () => {
        elementRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    };

    useEffect(function scrollElementIntoViewAfterSelecting(){
        if (isSelected) {
            scrollToElement()
        }
    }, [isSelected, scrollToElement])

    return (
        <div
            ref={elementRef}
            className={classnames('LocationItem', {
                selected: isSelected
            })}
        >
            <div>
                <Radio
                    disabled={isSelected}
                    checked={isSelected}
                    onChange={() => setSelectedLocation(location)}
                    className={'LocationItem_checkbox'}
                />
            </div>
            <div className={classnames('LocationItem_address', {
                selected: isSelected
            })}>
                <span>{buildLocationString(location)}</span>
            </div>
            <div>

                {
                    location.is_pinned ?
                        <Tooltip title={'Remove Pin'} arrow placement={'top'}>
                            <PushPinIcon
                                onClick={() => updatePinnedLocation(false)}
                                className={classnames('LocationItem-icon', {
                                    selected: isSelected
                                })}
                            />
                        </Tooltip>
                        :
                        <Tooltip title={'Pin location to calculate page'} arrow placement={'top'}>
                            <PushPinOutlinedIcon
                                onClick={() => updatePinnedLocation(true)}
                                className={classnames('LocationItem-icon', {
                                    selected: isSelected
                                })}
                            />
                        </Tooltip>
                }
            </div>
            <div>
                {
                    !isInitialLocation && !isDefaultLocation &&
                    <Tooltip title={'Delete Location'} arrow placement={'top'}>
                        <DeleteIcon
                            onClick={() => deleteLocation(location.id)}
                            className={classnames('LocationItem-icon delete', {
                                selected: isSelected
                            })}
                        />
                    </Tooltip>
                }
                {
                    isDefaultLocation &&
                    <Tooltip title={'Default Location'} arrow placement={'top'}>
                        <StarIcon
                            className={classnames('LocationItem-icon star', {
                                selected: isSelected
                            })}
                        />
                    </Tooltip>
                }
            </div>
        </div>
    )
}